import { Link } from "@mui/material";
import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const NoInformationStatus = ({ t, i18n }) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (i18n?.language === "en") {
      document.title =
        "Your application wasn’t approved - HARP - Government of Nova Scotia";
    } else {
      document.title =
        "Votre demande n’a pas été approuvée – PAC – Gouvernement de la Nouvelle-Écosse";
    }
  }, [i18n.language]);
  return (
    <div>
      <div className="container">
        <main>
          <article>
            <div className="row" style={{ paddingTop: "1em" }}></div>
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-sm-8">
                  <h2 style={{ marginBottom: 0 }}>
                    {t("application_status.no_response_title")}
                  </h2>
                  <br />
                  <Link
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate(`/${i18n.language}${t("routes.check_status")}`)
                    }
                  >
                    {t("application_status.try_again")}
                  </Link>
                  <br />
                  <br />
                  <p>{t("application_status.call_for_more_detail")}</p>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-sm-8">
                  <h3>{t("confirmation.questions")}</h3>
                  <h5>{t("application_status.contact_us")}</h5>
                </div>
              </div>
            </div>
          </article>
        </main>
      </div>
    </div>
  );
};

export default withTranslation("common")(NoInformationStatus);
